import { restRequest } from "vrcore-dashboard/dist/utilities";
export const VRCORE_GET_JOB_PACKS = restRequest("VRCORE.JOB_PACK_LIST_GET_JOB_PACKS");
export const VRCORE_REMOVE_JOB_PACK = restRequest("VRCORE.JOB_PACK_LIST_REMOVE_JOB_PACK");
export const VRCORE_SET_SEARCH = "VRCORE.JOB_PACK_LIST_SET_SEARCH";
export const VRCORE_SET_ORDERKEY = "VRCORE.JOB_PACK_LIST_SET_ORDERKEY";
export const VRCORE_SET_ORDERBY = "VRCORE.JOB_PACK_LIST_SET_ORDERBY";
export const SET_DATE_FROM = "VRCORE.JOB_PACK_LIST_SET_DATE_FROM";
export const SET_DATE_TO = "VRCORE.JOB_PACK_LIST_SET_DATE_TO";
